import {
	AllRolePermissions,
	PricingPlanNames,
	UserRole
} from "@/Contracts/Users";
import { useSelector } from "react-redux";
import { GlobalState } from "@/Reducers/interface";
import { checkUseFeatureAccess } from "@/Hooks/utils";

/**
 *
 * @param requiredPlan: Required pricing plan for the user to access this Feature.
 * If all users should be able to access this feature then pass **IGNITE**.
 * All the old accounts existing before pricing plan won't have any **PRICING PLAN** for their account
 * and will have access to all feature by default.
 *
 * @param requiredRole: Required User Role to access this feature.
 * If all users should be able to access this feature then pass **UserRole.UserRole**
 *
 * @description processes whether the user should be able to view feature based on the **USER ROLE** and
 * **CURRENT ACTIVE PRICING PLAN**
 */

export const useFeatureAccess = (
	requiredPlan: PricingPlanNames,
	requiredRole: UserRole,
	permissions?: AllRolePermissions[],
	skipPermissions?: boolean
): boolean => {
	const { userRole, rolePermissions, currentPlan } = useSelector(
		(state: GlobalState) => {
			let currentPlan = state.user.subscriptions.find(
				plan => plan.current_plan
			);
			const currentPlanFromSummary =
				state.user.subscriptionDetails.plan_id?.split("-")?.[0];
			if (!currentPlan && currentPlanFromSummary) {
				currentPlan = state.user.subscriptions.find(
					plan => plan.name === currentPlanFromSummary
				);
			}
			return {
				userRole: state.user.userData?.role,
				currentPlanFromSummary,
				rolePermissions:
					state.user.userData?.roles_permissions?.permissions,
				currentPlan
			};
		}
	);

	return checkUseFeatureAccess(userRole, rolePermissions, currentPlan)(
		requiredPlan,
		requiredRole,
		permissions,
		skipPermissions
	);
};
